'use client';

import {useEffect, useState} from 'react';

const ScrollToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const scrollToTop = () => window.scrollTo({top: 0, behavior: 'smooth'});

    return (
        <>
            <button
                onClick={scrollToTop}
                className={`fixed bottom-6 left-6 z-50 flex items-center justify-center
          w-14 h-14 rounded-full bg-primary bg-primary text-base leading-4 block text-white rounded-full font-semibold mt-8 hover:bg-dark duration-300 
          ${visible ? 'opacity-100 bounce' : 'opacity-0 pointer-events-none'}`}
                aria-label="Yukarı Çık"
            >
                <span style={{fontSize: '1.75rem', lineHeight: 1}}>↑</span>
            </button>
        </>
    );
};

export default ScrollToTop;
